<template>
  <section 
  id="as-section-testimonials"
  class="as-section as-section--has-padding as-section--testimonials"
  data-section="testimonials">
    <div class="container container--narrow">
      <h2 class="as-section__title"><span class="the-text">What People Are Saying</span></h2>
      <div class="row">
        <div class="col-lg-3 d-none d-lg-block">
          <div class="smiley-chat-bubble">
            <i class="fad fa-comments-alt text-dark-blue"></i>
          </div>
        </div>
        <div class="col-12 col-lg-9">
          <div class="testimonials-slider" ref="slider">

            <div 
              class="testimonials-slider__slide" 
              v-for="(testie, key) in testimonials" 
              :key="key">
                <div class="testimonials-slider__slide__inner">
                  <p class="testimonials-slider__slide__body">"<span v-html="testie.comments"></span>"</p>
                  <p class="testimonials-slider__slide__author">- {{testie.reviewer.firstName}} - {{testie.reviewDate}}</p>
                </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import WaypointMixin from '@vue/mixins/waypoint-mixin';
export default {
  mixins: [
    WaypointMixin
  ],
  props: {
    testimonials: { type: Array }
  },
  data(){
    return {
      slickInitialized: false
    }
  },
  mounted() {
    this.$emit('cmp-mounted');
    this.$addObserver(this.$el, this.onWaypointEnter, this.intersectionOptions);
  },

  methods: {
    initCarousel(){
      console.log('init carousel');
      $('.testimonials-slider').slick({
        dots: true,
        arrows: false,
        speed: 300,
        // autoplay: true,
        // autoplaySpeed: 3000,
        slidesToScroll: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1030,
                settings: {
                    arrows: false,
                    dots: true,
                    arrows: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    // dots: true
                    arrows: true,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
        
        
        // arrows: false,
        // dots: true,
        // autoplay: true,
        // autoplaySpeed: 3000,
      });
    }
  },
  
  watch: {
    testimonials(){
      console.log('testies changed');
      console.log('initialized', this.slickInitialized);
      console.log('testies', this.testimonials);
      setTimeout(() => {
        /**
         * The carousel was being initialized before the v-for loop had a chance to render the items into the DOM, causing carousel slides to stack on top of each other, unaffected by Slick
         */
        this.initCarousel();
      }, 10);
    }
  }
}
</script>